import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b9419dce&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=b9419dce&prod&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=b9419dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9419dce",
  null
  
)

export default component.exports